if (typeof ProductItem !== 'function') {
  class ProductItem extends HTMLElement {
    constructor() {
      super()
      this.handle = this.getAttribute('data-js-product-item')
      if (this.querySelector('variant-selector')) {
        this.init()
      }
    }
    init() {
      this.addEventListener('variant-selector:changed', async (event) => {
        const { id } = event.detail
        const url = new URL(window.location.origin + window.Shopify.routes.root)
        url.searchParams.set('view', 'item')
        url.searchParams.set('variant', id)
        url.pathname = url.pathname + 'products' + '/' + this.handle
        const response = await fetch(url)
        const htmlString = await response.text()
        const domElement = new DOMParser().parseFromString(htmlString, 'text/html')
        const image = this.querySelector('[data-js-replace="image"]')
        if (image) {
          image.innerHTML = domElement.querySelector('[data-js-replace="image"]').innerHTML
        }
        const text = this.querySelector('[data-js-replace="text"]')
        if (text) {
          text.innerHTML = domElement.querySelector('[data-js-replace="text"]').innerHTML
        }
      })
    }
  }

  if (typeof customElements.get('product-item') == 'undefined') {
    customElements.define('product-item', ProductItem)
  }
}
